import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class GetAiFutureEventsRequest extends BaseServiceRequest {
  constructor(payload) {
    super();
    super.addRequestUri("getFutureEvents");
    super.addRequestParameter("stock_id", payload.stock_id);
    super.addRequestParameter("current_date", payload.current_date);
    super.addRequestParameter("symbol", payload.symbol);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }
}

export default GetAiFutureEventsRequest;
